export const getLogoImageSrc = state => state.logo.imageSrc



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/logo/logo.selectors.js